import { PermissionType } from "@shared/api"
import { retryDynamicImport } from "@shared/lib"
import { materials, projectDetail, projects } from "@shared/routes"
import { RouteGuard } from "@shared/ui/route-guard"
import { Navigate, Outlet, RouteObject } from "react-router-dom"

export default [
	{
		path: projects,
		element: (
			<RouteGuard
				requiredPermissions={[
					PermissionType.Customer,
					PermissionType.SalesRepresentative,
				]}
			>
				<Outlet />
			</RouteGuard>
		),
		children: [
			{
				index: true,
				element: <Navigate to={materials} />,
			},
			{
				path: projectDetail,
				lazy: () =>
					retryDynamicImport(
						() => import("../project-detail/ui"),
					).then(m => ({
						Component: m.ProjectDetail,
					})),
			},
		],
	},
] satisfies RouteObject[]
